/* eslint-disable */

import React, { useState, useEffect } from "react";
import "./TutelaPerdite.scss";
import { useDispatch, useSelector } from "react-redux";
import Hero from "../../common/Hero/Hero";
import FiltersBox from "../../common/FiltersBox/FiltersBox";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContarctListWrapper from "../../../components/pages/ContractsPage/ContractListWrapper/ContractListWrapper";
import { LIST_CONTRACTS } from "../../../helpers/queries";
import { handlerErrors } from "../../../helpers/helpers";
import { hideLoading, showLoading } from "../../../reducers/app";
import { client } from "../../../App";
import Modal from "../../common/Modal/Modal";
import NoResult from "../../../components/common/NoResult/NoResult";

const TutelaPerdite = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [genericError, setGenericError] = useState(null);
  const [infoModal, setInfoModal] = useState({ active: false, type: null });
  const contract = useSelector((state) => state.contracts.current);

  const [filters, setFilters] = useState({});
  const [contracts, setContracts] = useState([]);
  const [filteredContracts, setFilteredContracts] = useState(contracts);
  const [firstRender, setFirstRender] = useState(false);

  // const lsContract = useSelector((state) => state.contracts.list);
  // let ID = lsContract.find((obj) => obj.id === contract.id);
  // console.log("IDIDIDIDIDI", ID);
  const filterConfig = {
    fields: [
      {
        label: t("bills.filters.contract"),
        name: "contratto",
        type: "contractDropDown",
        leftIcon: "lens",
        columnSize: "5",
      },
    ],
  };

  const onFiltersChanged = (e) => {
    console.log("SET FILTERED", e);
    setFilters(e);
  };

  const listContracts = async () =>
    client().query({
      query: LIST_CONTRACTS,
    });

  const columns = React.useMemo(
    () => [
      {
        Header: t("online.bills.table.contract"),
        accessor: "contratto",
        id: 1,
      },
      {
        Header: t("contract.serviceLoanLossProvisions"),
        accessor: "serviceLoanLossProvisions",
        id: 2,
      },
    ],
    [t]
  );

    const tutelaPerditeCheck = (isEnabled) => {
    return isEnabled ? (
    <button
      type="button"
      onClick={() => setInfoModal({ active: true, type: "DISABLE_TUTELA" })}
      className="underline link-style"
    >
      {t("contract.disable")}
    </button>
    ) : (
      <Link
        to="/tutela-perdite"
        className="underline link-style"
        aria-label={t("common.active")}
      >
        {t("common.active")}
      </Link>
    );
  };

  useEffect(() => {
    dispatch(showLoading());
    listContracts()
      .then(({ data }) => {
        if (data.listContracts.pagination.totalElements) {
          const formated = data.listContracts.elements.map(
            ({
              contractId,
              puf: { street, streetNumber, city },
              integraClientCode,
              integraContractCode,
              serviceLoanLossProvisions,
            }) => {
              return {
                contractId,
                integraClientCode,
                integraContractCode,
                contratto: `${integraClientCode} - ${integraContractCode} ${street} ${streetNumber} ${city} `,
                serviceLoanLossProvisions: tutelaPerditeCheck(
                  serviceLoanLossProvisions.enabled
                ),
              };
            }
          );

          setContracts(formated);
          dispatch(hideLoading());
          setTimeout(() => {
            setFirstRender(true);
          }, 0);
        } else {
          dispatch(hideLoading());
          setGenericError(t("contract.noContractFound"));
        }
      })
      .catch((err) => {
        handlerErrors(err, setGenericError, setGenericError);
      });
    // eslint-disable-next-line
  }, [contract]);

  const orderColumns = ["test1", "test2"];

  const renderInfoModal = () => {
    if (infoModal.type === "DISABLE_TUTELA") {
      return (
          <Modal
            descriptionClass={"active-section"}
            description={
              <>
                <span className="sp-text">
                  {t("contract.disableTutela.part1")}
                </span>
                <ul>
                  <li className="sp-text-block">
                    {t("contract.disableTutela.modal.part2")}
                  </li>
                  <li className="sp-text">
                    <a href={`mailto:fondoperdite@gruppocap.it`}>
                      {t("contract.disableTutela.modal.email")}
                    </a>
                  </li>
                </ul>
                <span className="sp-text-block">
                  {t("contract.disableTutela.part3")}
                </span>
              </>
            }
            show={true}
            type={"button"}
            onFirstClick={() => setInfoModal({ active: false, type: null })}
            linkTitle={t("common.hoCapito")}
          />
      );
    }
  };

  return (
    <div className="TutelaPerdite" data-testid="TutelaPerdite">
      <Hero
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("listCasePage.case.li.tutela_perdite")}
        description={t("listCasePage.case.li.tutela_perdite.description")}
        helpText={t('leakage_protection.help')}
      />
      <FiltersBox
        checkContractStatus={true}
        config={filterConfig}
        onChange={onFiltersChanged}
        data={contracts}
        onDataFiltered={setFilteredContracts}
        filter={(contracts) => {
          if (contract && contract.id && firstRender) {
            return contracts.filter(
              (element) =>
                element.integraContractCode === contract.clientId ||
                element.integraClientCode === contract.clientCode
            );
          } else {
            return contracts;
          }
        }}
      />
      {filteredContracts.length > 0 ? (
        <ContarctListWrapper
          hideData={true}
          columns={columns}
          data={filteredContracts}
          orderColumns={orderColumns}
          isDisablePage={false}
          disableContracts={(contracts) => console.log("contracts", contracts)}
          t={t}
        />
      ) : (
        <NoResult text={t("online.bills.noResults")} />
      )}

      {infoModal.active && renderInfoModal()}

      {/* {active && renderConfirmModal()} */}
    </div>
  );
};

TutelaPerdite.propTypes = {};

export default TutelaPerdite;
